// extracted by mini-css-extract-plugin
export var input = "input-module--input--382ce";
export var label = "input-module--label--34c40";
export var wrapper = "input-module--wrapper--51d79";